//#region : Imports

import
{
    NgModule
}
    from '@angular/core';

import
{
    CommonModule
}
    from '@angular/common';

import
{
    FormsModule
}
    from '@angular/forms';

import
{
    BrowserAnimationsModule
}
    from '@angular/platform-browser/animations';

import
{
    LoginComponent
}
    from './login/login.component';

import
{
    StatsComponent
}
    from './stats/stats.component';

import
{
    AnalyticsComponent
}
    from './analytics/analytics.component';

import
{
    MapViewComponent
}
    from './mapview/mapview.component';

import
{
    NguiMapModule
}
    from '@ngui/map';

import
{
    AngularResizedEventModule
}
    from 'angular-resize-event';
import
{
    AdminComponent
}
    from './admin/admin.component';
import
{
    RouterModule
}
    from '@angular/router';
import { SafePipe } from '../safe.pipe';
import
{
    NgxJsonViewerModule
}
    from 'ngx-json-viewer';


import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { AppModule } from '../app.module';


//#endregion

@NgModule(
    {
        declarations: [
            LoginComponent,
            StatsComponent,
            AnalyticsComponent,
            MapViewComponent,
            AdminComponent,
            SafePipe
        ],
        imports: [

            CommonModule,
            FormsModule,
            AngularResizedEventModule,
            BrowserAnimationsModule,
            RouterModule,
            NgxJsonViewerModule,
            NgxQRCodeModule,
            NguiMapModule.forRoot(
                {
                    apiUrl: 'https://maps.google.com/maps/api/js?libraries=visualization,places,drawing&key=AIzaSyD6IdEf_pshoZlYzqvDkWUy4PZ9blRiVe0'
                }),
        ],
        exports: [
            LoginComponent,
            StatsComponent,
            AnalyticsComponent,
            MapViewComponent,
            AdminComponent
        ]
    })
export class ComponentsModule
{ }